export default {
  reservations: 'Reservations',
  status: {
    CREATED: 'Created',
    WAITING_PAYMENT: 'Waiting Payment',
    WAITING_RENTAL: 'Reservation Created',
    ACTIVE: 'Active',
    CANCELED: 'Cancel',
    FINISHED: 'Finished',
    WAITING_REGISTRATION: 'Waiting Registration',
  },
  parameters: 'Parameters',
  serviceAreaOrder: 'Service Area Order',
  rentalPeriod: 'Rental Period',
  rentalCost: 'Rental Cost',
  reservationId: 'Reservation Id',
  startStationAddress: 'Start Station Address',
  startDate: 'Start Date',
  endStationAddress: 'End Station Address',
  endDate: 'End Date',
  kmLimit: 'Km Limit',
  kmPackageCost: 'Km Package Cost',
  order: 'Order',
  parameter: 'Parameter',
  rentalDays: 'Rental Days',
  pickupTime: 'Pick-up Time',
  dropoffTime: 'Drop-off Time',
  rentalTimeCost: 'Rental Time Cost',
  cancelReservation: 'Cancel Reservation',
  reservationWillBeCancelled: 'The reservation will be canceled. Are you sure ?',
  startStationName: 'Start Station Name',
  endStationName: 'End Station Name',
  taxNumber: 'Tax Number',
  firmCity: 'City',
  firmDistrict: 'District',
  addressLine: 'Address',
  firmMobile: 'Mobile',
  firmEmail: 'Email',
  firmTaxOfficeName: 'Tax Office',
  kmExceededCost: 'Km Exceeded Cost',
  reservationNumber: 'Reservation Number',
  channel: 'Channel',
  webReservations: 'Web Reservations',
  webReservationNumber: 'Web Rez. No',
  cancellationDate: 'Cancellation Date',
  reservationCancel: 'You are about to cancel the reservation. Please select the refund type:',
  corporateInvoiceRequest: 'Corporate Invoice Request',
  maxRefundableAmount: 'Maximum Refundable Amount',
  partialAmountGreaterError: 'Partial refund amount cannot be greater than the full refund amount.',
  refundCanEditable: 'The refund amount can be adjusted.',
  types: {
    DAILY: 'Daily',
    MONTHLY: 'Monthly',
  },
};
